<template>
  <div>
    <el-dialog :visible.sync="isShow" :title="$lang('修改接口地址')" width="800px"
      :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true" @close="close">
      <div class="title-style" slot="title">
        <div class="dialog_title">{{ $lang('发起联调') }}</div>
        <div class="bd_bottom"></div>
      </div>
      <div class="content">
        <div class="item">
          <span class="item-name">{{ $lang('API名称') }}：</span>
          <span class="item-value">{{info.name}}</span>
        </div>
        <div class="item">
          <span class="item-name">{{ $lang('执行结果') }}：</span>
          <span class="item-value">{{state === '0' ? $lang('未通过') : $lang('已通过') }}</span>
        </div>
        <div class="item">
          <span class="item-name">{{ $lang('API地址') }}：</span>
          <el-tooltip class="item" effect="dark" :open-delay="500" placement="top">
            <div class="item-value hide-font">{{url}}</div>
            <div slot="content" style="width:300px">{{url}}</div>
          </el-tooltip>
          <div class="copy" @click="copy(url)">{{ $lang('复制') }}</div>
        </div>
        <div class="item-other">
          <span class="item-name">{{ $lang('请求格式') }}：</span>
          <span class="item-value">JSON</span>
        </div>
        <div class="item-other">
          <span class="item-name">{{ $lang('响应格式') }}：</span>
          <span class="item-value">JSON</span>
        </div>
        <div class="item-other">
          <span class="item-name">{{ $lang('编码格式') }}：</span>
          <span class="item-value">UTF-8</span>
        </div>
        <div class="item">
          <span class="item-name">apiAccount: </span>
          <span class="item-value">{{apiAccount}}</span>
        </div>
        <div class="item">
          <span class="item-name">digest: </span>
          <span class="item-value">{{digest}}</span>
        </div>
      </div>
      <div class="content-foot">
        <div class="left-content">
          <div style="display: flex;align-items: center;justify-content: space-between;">
            <span class="http-title">{{ $lang('请求参数') }}</span>
            <el-dropdown @command="tempClick" v-if="info.interfaceType === 1 && isShow" trigger="click">
              <span class="el-dropdown-link">
                {{ $lang('选择模板') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, index) in tempList" :key="index" :command="item.label">{{$lang(item.label)}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div>
            <el-input type="textarea" :rows="8" :placeholder="$lang('请输入内容')" v-model="requestText" :disabled="info.interfaceType === 1"></el-input>
          </div>
        </div>
        <div class="right-content">
          <span class="http-title">{{ $lang('响应参数') }}</span>
          <div>
            <json-viewer class="pre_api" copyable :expanded="true" :show-double-quotes="true" :expand-depth="5" :value="responseText">
              <template v-slot:copy="{ copied }">
                <span class="copy-btn" v-if="copied">{{ $lang('复制成功') }}</span>
                <span class="copy-btn" v-else>{{ $lang('复制') }}</span>
              </template>
            </json-viewer>
<!--            <el-input type="textarea" :rows="8" :placeholder="$lang('请输入内容')" v-model="responseText" disabled></el-input>-->
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="info.interfaceType === 1" @click="start">{{ $lang('下发报文') }}</el-button>
        <el-button type="primary" @click="start" v-else :loading="btnLoading">{{ $lang('开始测试') }}</el-button>
        <el-button @click="close">{{ $lang('关闭') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { RESPONSE_SUCCESS } from '@/constants'
import axios from 'axios'
import templateList from '../requestTemplate.js'
import { formatJSON } from '@/utils/index.js'
import JsonViewer from 'vue-json-viewer'
export default {
  name: 'LianTiao',
  components:{ JsonViewer },
  data() {
    return {
      isShow: false,
      info: {},
      state: '0', // 0-未通过  1-联调通过
      responseText: {},
      requestText: '',
      tempList: [],
      url : '',
      privatekey: '9e31bd78258642da89fa8880aa2d678f',
      apiAccount: '679256380346990601',
      btnLoading: false,
      digest: ''
    }
  },
  computed: {
    ...mapGetters(['uuid']),
  },
  methods: {
    init(row) {
      this.state = '0'
      this.digest = ''
      this.requestText = ''
      this.responseText = {}
      this.tempList = []
      this.isShow = true
      this.info = row
      this.state = this.info.testNum ? '1' : '0'
      if (row.interfaceType === 1) { // 注册类
        this.url = this.info.testUrl
        this.tempList = templateList[row.interfaceId]
      } else {
        this.url = this.info.url ? this.info.url + '?uuid=' + this.uuid + '&pid=' + row.pid : ''
        this.tempList = []
      }
    },
    close() {
      this.$emit('selectApiClose')
      this.btnLoading = false
      this.isShow = false
    },
    start() {
      this.btnLoading = true
      // if (this.info.interfaceType === 1) {
      //   this.getLiantiao()
      // } else {
      //   this.getHttp({ url: this.url, params: this.requestText })
      // }
      this.getLiantiao()
    },
    /**
     * @description  json秘钥签名
     */
    async headersSign(param){
      const res = await this.$API.headersSign({ privateKey: this.privatekey, json: param })
      if (res.code === RESPONSE_SUCCESS) {
        return res.data
      }
    },
    /**
     * @description 注册类接口联调
     */
    async getLiantiao() {
      try {
        this.digest = await this.headersSign(formatJSON(this.requestText, true))
        const param = { id: this.info.id, urlCallback: this.url, bizContent: this.requestText }
        const res = await this.$API.liantiao(param)
        if (res.code === RESPONSE_SUCCESS) {
          this.$message.success(this.$lang('联调通过'))
          this.state = '1'
          this.responseText = JSON.parse(res.data)
        } else {
          this.$message.error(res.msg)
          console.log(res.data , 'res.data ')
          this.responseText = res.data || res
        }
        this.btnLoading = false
      } catch(err) {
        console.log(err)
        this.digest = ''
        this.btnLoading = false
        this.$message.error(this.$lang('联调失败，请联系客服获取技术支持。'))
      }
    },
    /**
     * @description 订阅类接口联调
     */
    async getHttp(option) {
      this.digest = await this.headersSign(formatJSON(option.params, true))
      const formData = new FormData()
      formData.append('bizContent', formatJSON(option.params, true))
      axios({
        url: option.url,
        method:"POST",
        data: formData,
        headers:{
          'Content-Type':'application/X-WWW-FORM-URLENCODED;charset=UTF-8',
          'apiAccount': this.apiAccount,
          'digest': this.digest,
          'timestamp': Date.now()
        }
      }).then(res => {
        const { code, msg } = res.data
        if (code === '1') {
          this.$message.success(this.$lang('联调通过'))
          this.state = '1'
          this.responseText = res.data
        } else {
          this.$message.error(msg)
          this.responseText = res.data
        }
        this.btnLoading = false
      }).catch(err => {
        console.log(err)
        this.digest = ''
        this.btnLoading = false
        this.$message.error(this.$lang('联调失败，请联系客服获取技术支持。'))
      })
    },
    copy(url) {
      const input = document.createElement("input");
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.open()
    },
    open() {
      this.$notify.success({
        title: this.$lang('成功复制API地址'),
        duration: 3000,
        showClose: false,
        message: ''
      });
    },
    tempClick(com) {
      this.requestText = this.tempList.find(v => v.label === com).value
    }
  }
}
</script>
<style lang="scss" scoped>
.title-style {
  .dialog_title {
    padding: 20px 0 17px 40px;
    font-size: 20px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 700;
    text-align: left;
    color: #2b2b2b;
  }
  .bd_bottom {
    height: 1px;
    background: #d9d9d9;
    border-radius: 6px;
  }
}
.content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .item {
    display: flex;
    align-items: center;
    width: 376px;
    padding: 5px 0;
    .item-name, .item-value {
      height: 30px;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Medium;
      text-align: left;
      color: #2b2b2b;
      line-height: 30px;
    }
    .item-name {
      font-weight: 600;
      width: 100px;
    }
    .item-value {
      width: 230px;
      font-weight: 400;
    }
    .copy {
      padding-left: 5px;
      font-size: 14px;
      color:#E60000;
      cursor: pointer;
    }
    .copy:hover {
      text-decoration:underline;
    }
    .hide-font {
      display: inline-block;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
  }
  .item-other {
    width: 120px;
    padding: 5px 0;
    .item-name, .item-value {
      height: 30px;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Medium;
      text-align: left;
      color: #2b2b2b;
      line-height: 30px;

    }
    .item-name {
      font-weight: 600;
      width: 80px;
    }
    .item-value {
      width: 50px;
      font-weight: 400;
    }
  }
}
.content-foot {
  display: flex;
  justify-content: space-between;
  .left-content {
    width: 47%;
    .el-dropdown-link {
      cursor: pointer;
      color: #E60000;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
  }
  .right-content {
    width: 49%
  }
  .left-content, .right-content {
    .http-title {
      width: 56px;
      height: 30px;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #2b2b2b;
      line-height: 30px;
    }
  }
}
::v-deep .el-input__inner {
  border-radius: 6px !important;
}
::v-deep .el-dialog__header {
  padding: 0 !important;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
::v-deep .el-dialog {
  border-radius: 6px;
}
// json高亮 代码
.pre_api {
  background: #f9fafc;
  border: 1px solid $table-border-color;
  border-radius: 4px;
  box-sizing: border-box;
  max-height: 400px;
  overflow: auto;
  height: 180px;
  .copy-btn {
    font-size: 12px;
    color: #E60000;
  }
}
</style>
